<section class="tem">
  <!-- Faixa de contexto — FORA das abas, sempre visível. Os números de qualquer
       aba descrevem só o recorte filtrado (aquele usuário, aquele período),
       nunca o histórico inteiro; se esta frase sumisse ao trocar de aba, a tela
       passaria a mentir por omissão em três das quatro. -->
  <div class="tem__context" role="status">
    <span class="tem__context-item">{{ model().contexto }}</span>
    <span class="tem__context-item">
      Total <strong>{{ model().totalDuracao }}</strong>
    </span>
    <span class="tem__context-item">Meta de {{ model().metaDiariaHoras }}h por dia útil</span>
  </div>

  @if (model().isEmpty) {
    <p class="tem__empty">Nenhum apontamento no recorte atual.</p>
  } @else {
    <p-tabs [value]="activeTab()" (valueChange)="activeTab.set($any($event))">
      <p-tablist>
        <p-tab value="visao"><i class="pi pi-chart-bar"></i> Visão geral</p-tab>
        <p-tab value="distribuicao"><i class="pi pi-chart-pie"></i> Distribuição</p-tab>
        <p-tab value="chamados"><i class="pi pi-ticket"></i> Chamados</p-tab>
        <p-tab value="qualidade"><i class="pi pi-verified"></i> Qualidade</p-tab>
      </p-tablist>

      <p-tabpanels>
        <!-- ================= VISÃO GERAL ================= -->
        <p-tabpanel value="visao">
          <p class="tem__tab-lead">
            Quanto foi apontado, e como esse tempo se espalhou pelos dias.
          </p>

          <section class="tem__section" aria-labelledby="tem-resumo">
            <h3 id="tem-resumo" class="tem__title">Resumo do período</h3>
            <div class="tem__grid">
              @for (card of model().cards; track card.key) {
                <app-metric-card [model]="card" />
              }
            </div>
          </section>

          <section class="tem__section" aria-labelledby="tem-por-dia">
            <div class="tem__section-header">
              <div>
                <h3 id="tem-por-dia" class="tem__title">Horas por dia</h3>
                <p class="tem__hint">Os dias sem apontamento aparecem zerados.</p>
              </div>
              <label class="tem__switch">
                <p-toggleSwitch
                  [ngModel]="esconderFimDeSemana()"
                  (ngModelChange)="onEsconderFimDeSemanaChange($event)" />
                Esconder sábados e domingos
              </label>
            </div>
            @if (porDiaExibido().length > 0) {
              <div class="tem__chart" role="img" aria-label="Horas apontadas por dia do período">
                @for (dia of porDiaExibido(); track dia.key) {
                  <div class="tem__bar-wrap">
                    <!-- A barra mede sua altura em % de `.tem__bar-plot`, não do
                         `.tem__bar-wrap` inteiro — se medisse do wrap, o espaço que
                         o texto abaixo ocupa entraria na conta e uma barra de 100%
                         sobreporia o texto (foi o que quebrou ao entrar a 3ª linha,
                         do dia da semana). -->
                    <div class="tem__bar-plot">
                      <div
                        class="tem__bar"
                        [class.tem__bar--success]="dia.severity === 'success'"
                        [class.tem__bar--warning]="dia.severity === 'warning'"
                        [class.tem__bar--danger]="dia.severity === 'danger'"
                        [style.height.%]="dia.alturaPercent"
                        [style.min-height.px]="dia.minutos > 0 ? 2 : 0"
                        [attr.title]="
                          dia.label + ': ' + dia.duracao + ' · ' + dia.chamados + ' chamado(s)'
                        "></div>
                    </div>
                    <span class="tem__bar-value">{{ dia.duracao }}</span>
                    <span class="tem__bar-label">{{ dia.label }}</span>
                    <span class="tem__bar-weekday">{{ dia.diaSemana }}</span>
                  </div>
                }
              </div>
            } @else {
              <!-- Período todo em fim de semana com o switch ligado: gráfico
                   vazio sem explicação pareceria defeito. -->
              <p class="tem__chart-empty">
                O período filtrado cai só em sábados e domingos, escondidos pelo switch acima.
              </p>
            }
            <!-- A linha de meta fica FORA do gráfico de propósito: desenhá-la sobre as
                 barras exigiria escala absoluta, e as barras são relativas ao maior
                 dia — a linha cairia no lugar errado sempre que alguém apontasse mais
                 que a meta. -->
            <p class="tem__chart-note">
              Verde = acima de 75% da meta de {{ model().metaDiariaHoras }}h; amarelo = entre 50% e
              75%; vermelho = abaixo de 50%.
            </p>
          </section>
        </p-tabpanel>

        <!-- ================= DISTRIBUIÇÃO ================= -->
        <p-tabpanel value="distribuicao">
          <p class="tem__tab-lead">
            Onde o tempo foi parar — por natureza do trabalho e por destino.
          </p>

          <section class="tem__section" aria-labelledby="tem-tipo">
            <h3 id="tem-tipo" class="tem__title">Natureza do trabalho</h3>
            <p class="tem__hint">
              A fatia de <strong>Erro</strong> é a leitura gerencial daqui: é o retrabalho.
            </p>
            <app-distribution-bar [slices]="model().porTipo" mode="rows" />
          </section>

          <section class="tem__section" aria-labelledby="tem-atendimento">
            <h3 id="tem-atendimento" class="tem__title">Interno × Externo</h3>
            <app-distribution-bar [slices]="model().porAtendimento" mode="stacked" />
          </section>

          <div class="tem__row">
            <section class="tem__section" aria-labelledby="tem-cliente">
              <h3 id="tem-cliente" class="tem__title">Por cliente</h3>
              <app-distribution-bar [slices]="model().porCliente" mode="rows" />
            </section>

            <section class="tem__section" aria-labelledby="tem-sistema">
              <h3 id="tem-sistema" class="tem__title">Por sistema</h3>
              <app-distribution-bar [slices]="model().porSistema" mode="rows" />
            </section>

            <!-- O responsável é o campo `ticket.responsible` — o mesmo da
                 coluna "Responsável" na listagem de chamados. Não vem do
                 apontamento (o backend não guarda setor por apontamento). -->
            <section class="tem__section" aria-labelledby="tem-responsavel">
              <h3 id="tem-responsavel" class="tem__title">Por responsável</h3>
              <app-distribution-bar [slices]="model().porResponsavel" mode="rows" />
            </section>
          </div>

          <!-- Comparar carga só faz sentido com mais de uma pessoa no filtro; com uma
               só, a barra seria uma linha de 100% dizendo nada. -->
          @if (model().mostrarPorUsuario) {
            <section class="tem__section" aria-labelledby="tem-usuario">
              <h3 id="tem-usuario" class="tem__title">Por usuário</h3>
              <p class="tem__hint">Clique numa linha para filtrar a tela por essa pessoa.</p>
              <app-distribution-bar
                [slices]="model().porUsuario"
                mode="rows"
                (sliceClick)="onSliceActivate($event)" />
            </section>
          }
        </p-tabpanel>

        <!-- ================= CHAMADOS ================= -->
        <p-tabpanel value="chamados">
          <p class="tem__tab-lead">
            Quais chamados consumiram o tempo, e como isso se compara ao estimado.
          </p>

          <section class="tem__section" aria-labelledby="tem-top">
            <h3 id="tem-top" class="tem__title">Maior consumo no período</h3>
            <ul class="tem__list">
              @for (item of model().topChamados; track item.ticketId) {
                <li class="tem__list-item">
                  <span class="tem__list-number">{{ item.numero }}</span>
                  <span class="tem__list-main">
                    <span class="tem__list-summary">{{ item.resumo }}</span>
                    <span class="tem__list-customer">{{ item.cliente }}</span>
                  </span>
                  <span class="tem__list-detail">{{ item.detalhe }}</span>
                </li>
              }
            </ul>
          </section>

          <!-- Ausente quando NENHUM chamado do recorte tem estimativa: um bloco de
               zeros afirmaria "ninguém estourou", que é diferente de "não há
               estimativa cadastrada". -->
          @if (model().estimativa; as estimativa) {
            <section class="tem__section" aria-labelledby="tem-estimativa">
              <h3 id="tem-estimativa" class="tem__title">Realizado no período × estimado total</h3>
              <p class="tem__warn">
                <i class="pi pi-info-circle" aria-hidden="true"></i>
                <span>
                  As horas comparadas são apenas as do recorte filtrado — não o histórico completo
                  do chamado. Logo, o consumo real é <strong>igual ou maior</strong> que o mostrado
                  aqui: quem já aparece acima de 100% estourou com certeza.
                </span>
              </p>
              <p class="tem__subtitle">
                {{ estimativa.comEstimativa }} de {{ estimativa.totalChamados }} chamado(s) com
                estimativa cadastrada · <strong>{{ estimativa.estouros }}</strong> acima de 100%
              </p>
              <ul class="tem__list">
                @for (item of estimativa.itens; track item.ticketId) {
                  <li class="tem__list-item" [class.tem__list-item--danger]="item.estourou">
                    <span class="tem__list-number">{{ item.numero }}</span>
                    <span class="tem__list-main">
                      <span class="tem__list-summary">{{ item.resumo }}</span>
                      <span class="tem__list-customer">{{ item.cliente }}</span>
                    </span>
                    <span class="tem__list-detail">
                      {{ item.apontado }} / {{ item.estimado }} · {{ item.percentConsumo }}%
                    </span>
                  </li>
                }
              </ul>
            </section>
          }
        </p-tabpanel>

        <!-- ================= QUALIDADE ================= -->
        <p-tabpanel value="qualidade">
          <p class="tem__tab-lead">
            O que o apontamento em si diz — e o que ele deixa de dizer. Serve tanto para revisar o
            próprio registro quanto para achar erro de dado.
          </p>

          <section class="tem__section" aria-labelledby="tem-descricao">
            <h3 id="tem-descricao" class="tem__title">Descrição</h3>
            <div class="tem__quality">
              <div class="tem__quality-item">
                <span class="tem__quality-value">{{ model().qualidade.semDescricao }}</span>
                <span class="tem__quality-label">
                  sem descrição ({{ model().qualidade.semDescricaoPercent }}%)
                </span>
              </div>
              <div class="tem__quality-item">
                <span class="tem__quality-value">{{ model().qualidade.descricaoCurta }}</span>
                <span class="tem__quality-label">descrição muito curta</span>
              </div>
            </div>
          </section>

          <section class="tem__section" aria-labelledby="tem-suspeitos">
            <h3 id="tem-suspeitos" class="tem__title">Registros suspeitos</h3>
            <p class="tem__hint">
              Não são erros por definição — são os casos que mais valem uma conferida.
            </p>
            <div class="tem__quality">
              <div class="tem__quality-item">
                <span class="tem__quality-value">{{ model().qualidade.blocosLongos }}</span>
                <span class="tem__quality-label">blocos acima de 8h</span>
              </div>
              <div class="tem__quality-item">
                <span class="tem__quality-value">{{ model().qualidade.blocosCurtos }}</span>
                <span class="tem__quality-label">blocos abaixo de 5min</span>
              </div>
              <div class="tem__quality-item">
                <span class="tem__quality-value">{{ model().qualidade.atravessamMeiaNoite }}</span>
                <span class="tem__quality-label">atravessam a meia-noite</span>
              </div>
              <div class="tem__quality-item">
                <span class="tem__quality-value">{{ model().qualidade.emAberto }}</span>
                <span class="tem__quality-label">ainda em aberto</span>
              </div>
              <!-- Sobreposição não é métrica de produtividade: é erro de dado. A
                   mesma hora contada duas vezes infla TODOS os totais das outras
                   abas, então é o único item daqui com destaque de alerta. -->
              <div
                class="tem__quality-item"
                [class.tem__quality-item--danger]="model().qualidade.sobreposicoes > 0">
                <span class="tem__quality-value">{{ model().qualidade.sobreposicoes }}</span>
                <span class="tem__quality-label">sobrepostos (mesma pessoa)</span>
              </div>
            </div>
          </section>

          <section class="tem__section" aria-labelledby="tem-ritmo">
            <h3 id="tem-ritmo" class="tem__title">Cobertura e ritmo</h3>
            <div class="tem__quality">
              <div class="tem__quality-item">
                <span class="tem__quality-value">{{ model().qualidade.lacunas }}</span>
                <span class="tem__quality-label">não apontado entre marcações</span>
              </div>
              <div class="tem__quality-item">
                <span class="tem__quality-value">{{ model().qualidade.chamadosPorDia }}</span>
                <span class="tem__quality-label">chamados por dia (troca de contexto)</span>
              </div>
              <div class="tem__quality-item">
                <span class="tem__quality-value">{{ model().qualidade.duracaoMediaBloco }}</span>
                <span class="tem__quality-label">duração média do bloco</span>
              </div>
            </div>
          </section>
        </p-tabpanel>
      </p-tabpanels>
    </p-tabs>
  }
</section>
